// ANCHOR React
import React from 'react';

// ANCHOR Base
import { CLOSE_SOURCE, Modal, ModalProps } from 'baseui/modal';

interface ICloseSourceProps {
  closeSource?: keyof typeof CLOSE_SOURCE;
}

export const CloseModal = React.memo(({
  children,
  isOpen,
  onClose,
  animate,
  autoFocus,
  focusLock,
  closeable,
  mountNode,
  overrides,
  role,
  size,
}: ModalProps) => {
  const onCloseButtonOnly = React.useCallback(
    ({ closeSource }: ICloseSourceProps) => {
      if (onClose && closeSource === CLOSE_SOURCE.closeButton) {
        onClose({ closeSource });
      }
    },
    [onClose],
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCloseButtonOnly}
      animate={animate}
      autoFocus={autoFocus}
      focusLock={focusLock}
      closeable={closeable}
      mountNode={mountNode}
      overrides={overrides}
      role={role}
      size={size}
    >
      {children}
    </Modal>
  );
});
